export default "__VITE_ASSET__BEs7b96x__"